import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import useStyles from './styles';
import moment from 'moment';

class LandingPage extends Component {
    constructor(props){
        super(props);
    }

    render(){
        const { classes, chapter } = this.props;
        const today = moment();

        return (
            <div style={{width: '100%', textAlign: 'center'}}>
        {
            chapter && moment(chapter.chapter_end_date).isSameOrBefore(today) ?
            <p className={classes.landingP}>
                Questions for {moment(chapter.chapter_end_date).format('MMMM Do')} closed at {moment(chapter.chapter_end_date).format('h:mm a')}.<br/>
                Please check back after the schedule is posted for tomorrow's questions.
            </p>
            :
            <p className={classes.landingP}>
                Tennis matches aren’t set just yet.<br/>
                We will email you once the Tennis Pick’em Challenge is live.
            </p>
        }
            </div>
        )
    }
}

export default withStyles(useStyles)(LandingPage);